export default __webpack_public_path__ + "static/media/bkg--home-1.760e2ae1.jpg";